// @flow
import * as wjcCore from 'wijmo/wijmo';

const populateGroupPanels = groups => {
  let result = []
  if (Array.isArray(groups) && groups.length > 0) {
    result = groups.map(colName => {
      return new wjcCore.PropertyGroupDescription(colName);
    });
  }

  return result;
};

const resetAndPopulateGroupPanels = (
  groups: Array<string>,
  collection: any,
) => {
  // Always clear existing groups first
  collection.groupDescriptions.clear();
  
  // Then add new groups if any
  const groupDescArray = populateGroupPanels(groups)
  if (Array.isArray(groupDescArray) && groupDescArray.length > 0) {
    groupDescArray.forEach(item => {
      collection.groupDescriptions.push(item);
    });
  }
};

export { resetAndPopulateGroupPanels, populateGroupPanels };
